module.exports = __webpack_public_path__ + "static/media/voting.4fe3bb87.svg";